import { render, staticRenderFns } from "./IconStripMenu.vue?vue&type=template&id=4505297c&scoped=true"
import script from "./IconStripMenu.vue?vue&type=script&lang=js"
export * from "./IconStripMenu.vue?vue&type=script&lang=js"
import style0 from "./IconStripMenu.vue?vue&type=style&index=0&id=4505297c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505297c",
  null
  
)

export default component.exports